// extracted by mini-css-extract-plugin
module.exports = {"shimmer-wrapper":"_3FRJu","shimmer":"b8A-d"};